export default __webpack_public_path__ + "static/6-a1b1e61c2f9dbd1e45ee2f35c6689073.jpg";